<!--
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-20 10:54:14
 * @LastEditTime: 2020-12-09 13:44:43
 * @FilePath: \ensurance-front\src\components\header-common\index.vue
-->
<template>
  <div class="header-common">
    <div class="header-title-wrap">
      <div class="header-title">
        <span>保单录入系统</span>
      </div>
    </div>
    <div class="user-info">
      <span>{{ nowData }}</span>
      <span>{{ weekDay }}</span>
      <span>{{ userName }}</span>
      <el-button type="text" @click="logOut">退出登录</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userName: '',
      weekDay: '',
      nowData: ''
    }
  },
  methods: {
    logOut() {
      this.$confirm('退出系统, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit('clearToken')
        this.$router.push('/login')
      })
    }
  },
  created() {
    this.weekDay = this.$moment().format('dddd')
    this.nowData = this.$moment().format('ll')
    this.userName = this.$store.getters.userInfo.FirstName
  }
}
</script>

<style lang="scss" scoped>
  .header-common {
    background: #2a2a2a;
    opacity: 1;
    height: 60px;
    .header-title-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 60px;
      width: 230px;
      background-color: #826e5e;
    }
    .header-title {
      color: white;
      display: flex;
      font-size: 24px;
      align-items: center;
      justify-content: center;
      font-family: zihun35hao-jindianyahei;
      background-color: #826e5e;
      height: 60px;
    }
    .header-title-wrap::after {
      width: 0px;
      position: relative;
      left: 58px;
      display: block;
      content: '';
      border-top: 30px solid transparent;
      border-left: 30px solid #826e5e;
      border-bottom: 30px solid transparent;
    }
    .user-info {
      line-height: 60px;
      position: absolute;
      right: 0;
      top: 0;
      color: #fff;
      font-size: 16px;
      padding-right: 20px;
      .el-button {
        color: #fff;
        &:hover {
          color: #f48f62;
        }
      }
      span {
        display: inline-block;
        margin-right: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header-common/index.vue